const LessonsRoutes = [
  {
    path: '',
    name: 'lessons',
    component: () => import(/* webpackChunkName: "lessonsRoot" */ '@/views/Lessons/LessonsRoot'),
  },
  {
    path: ':id/:subId',
    name: 'lessonsActivity',
    component: () => import(/* webpackChunkName: "lessonsActivity" */ '@/views/Lessons/LessonsActivity'),
  },
  {
    path: 'text/:id/:subId',
    name: 'lessonsText',
    component: () => import(/* webpackChunkName: "lessonsActivity" */ '@/views/Lessons/LessonsText'),
  }
]

export default LessonsRoutes
